import { Style } from '@core/interfaces/styles/styles.interface';
import { kebabCase } from 'lodash';
import { getBgSizeForAnimationName } from './styles-helpers';

const groupClassNames = ['active'];
const parentClassNames = ['scrolled'];

export class StyleGroupBuilder {
  static build(blockId: string, groupName: string, styles: Style): string {
    let _styles = '';
    // na wypadek, jeśli null
    if (!styles) {
      return _styles;
    }
    if (Object.prototype.hasOwnProperty.call(styles, 'animationName')) {
      const stylesForAnimation = StyleGroupBuilder.getStyleForAnimation(styles.animationName);
      styles = {
        ...styles,
        ...stylesForAnimation,
      };
    }
    if (Object.prototype.hasOwnProperty.call(styles, 'overflow')
      && styles.overflow === 'hidden'
      && Object.prototype.hasOwnProperty.call(styles, 'minHeight')
      && !Object.prototype.hasOwnProperty.call(styles, 'height')) {

      styles = {
        ...styles,
        height: styles.minHeight,
      };
    }
    if (Object.prototype.hasOwnProperty.call(styles, 'flexDirection')
      && !Object.prototype.hasOwnProperty.call(styles, 'display')) {

      styles = {
        ...styles,
        display: 'flex',
      };
    }
    // create styles
    const stylesString = StyleGroupBuilder.toDeclarationString(styles);

    if (parentClassNames.includes(groupName)) {
      _styles = `.${groupName} ${blockId}{${stylesString}}`;
    }
    // check if can create cass by pseudo class
    if (groupClassNames.includes(groupName)) {
      _styles = `${blockId}__${groupName}{${stylesString}}`;
    }

    const groupSting = groupName === 'basic' ? '' : `:${groupName}`;
    _styles = `${blockId}${groupSting}{${stylesString}}` + _styles;

    return _styles;
  }

  static toDeclarationString(styles: Style): string {
    return Object.entries(styles)
      .reduce((p, [key, value]) => {
        const prefix = key.startsWith('--')
          ? '--'
          : (key.startsWith('-')
              ? '-'
              : ''
          );
        return p + '' + `${prefix}${kebabCase(key)}:${value};`;
      }, '');
  }

  private static getStyleForAnimation(animationName: string) {
    const animationStyle: Record<string, string> = {};
    const bgSize = getBgSizeForAnimationName(animationName);
    if (bgSize) {
      animationStyle.backgroundSize = bgSize;
    }
    return animationStyle;
  }
}
